import mazzucato from "../../../../data-models/mission-oriented-innovation-process/mazzucato.jsonc";
import * as React from 'react';
export default {
  mazzucato,
  React
};